import { Star1 } from 'iconsax-react';
import React from 'react';

export const renderStars = (rate: number): React.JSX.Element | null => {
    if (!(rate > 0)) return null;
    // Assuming 5 as the maximum rating
    const stars: React.JSX.Element[] = [];
    for (let i = 1; i <= rate; i++) {
        stars.push(
            <Star1
                key={`filled-star-${i}`}
                className='fill-text dark:fill-white'
                strokeWidth={1.5}
                size={20}
            />,
        );
    }
    for (let i = 1; i <= 5 - rate; i++) {
        stars.push(<Star1 key={`empty-star-${i}`} strokeWidth={1.5} size={20} />);
    }
    return <div className='my-3 flex'>{stars}</div>;
};
